import { render } from "./Physicians.vue?vue&type=template&id=3a1a811c&scoped=true"
import script from "./Physicians.vue?vue&type=script&lang=js"
export * from "./Physicians.vue?vue&type=script&lang=js"

import "./Physicians.vue?vue&type=style&index=0&id=3a1a811c&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-3a1a811c"

export default script